<template>
	<div class="AResult">
		<div class="topbanner">
			<img src="../static/2_5.jpg" alt="">
			<p class="title">
				齐白石 陈半丁 松鼠荔枝图 立轴
			</p>
		</div>
		<ul class="infoList">
			<li>
				估值：
				<span class="number">6,000-8,000RMB</span>
			</li>
			<li style="border-bottom: none;">
				<p>估值价格通过相似作品市场价格信分析所得</p>
			</li>
		</ul>
		<div class="tipwarp">
			<div class="Mtip">
				<p>免责声明：</p>
				<p>估值结果仅视为此作品为真品的价格参考；</p>
				<p>不作为判断作品真伪、物权、版权的依据； </p>
				<p>不作为交易、抵押、融资、贷款、资产置换及保险索赔的依据。</p>
			</div>
		</div>
		<div class="warpC">
			<h4>相似作品</h4>
			<div class="Clist">
				<ul>
					<li>
						<dl>
							<dt><img src="../static/2_5.jpg" alt=""></dt>
							<dd>
								<p>中国嘉德2017春季拍卖会中国嘉德春季拍卖会中国嘉德春季拍卖会中国…</p>
								<span>10万-15万USD</span>
							</dd>
						</dl>
					</li>
					<li>
						<dl>
							<dt><img src="../static/2_5.jpg" alt=""></dt>
							<dd>
								<p>中国嘉德2017春季拍卖会中国嘉德春季拍卖会中国嘉德春季拍卖会中国…</p>
								<span>10万-15万USD</span>
							</dd>
						</dl>
					</li>
					<li>
						<dl>
							<dt><img src="../static/2_5.jpg" alt=""></dt>
							<dd>
								<p>中国嘉德2017春季拍卖会中国嘉德春季拍卖会中国嘉德春季拍卖会中国…</p>
								<span>10万-15万USD</span>
							</dd>
						</dl>
					</li>
					<li>
						<dl>
							<dt><img src="../static/2_5.jpg" alt=""></dt>
							<dd>
								<p>中国嘉德2017春季拍卖会中国嘉德春季拍卖会中国嘉德春季拍卖会中国…</p>
								<span>10万-15万USD</span>
							</dd>
						</dl>
					</li>
				</ul>
			</div>
		</div>
		<div class="gbutn">我也来估值一下</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return{
				data:''
			}
		},
		mounted(){

		},
		methods:{
			getData(){

			}
		}
	}
</script>
<style scoped>
	.AResult{
		width: 100%;
		height: 100%;
		background:#F7F7F7
	}
	.topbanner{
		width: 100%;
	}
	.topbanner img{
		width: 100%;
	}
	.title{
		width: 100%;
		height:.65rem;
		background:#fff;
		line-height:.65rem;
		font-size: 16px;
		color:#27282D;
		text-indent: .15rem;
	}
	.infoList{
		background: #fff;
		margin-top: 0.05rem;
	}
	.infoList li{
		height: 0.48rem;
		line-height: 0.48rem;
		font-size: 15px;
		text-indent: 0.15rem;
		border-bottom: 1px solid #ccc;
	}
	.infoList li .number{
		margin-left: 0.43rem;
		color:#DD2815;
	}
	.infoList li p{
		font-size:15px;
		color:#969696;
	}
	.tipwarp{
		width: 100%;
		background:#fff;
		padding-bottom: 0.15rem;
	}
	.Mtip{
		width: 84%;
	    height: 1.2rem;
	    background: rgba(245,245,245,1);
	    border-radius: 5px;
	    margin: 0 auto;
	    padding: 0.15rem;
	}
	.Mtip p{
		font-size: 13px;
		color:#969696;
		line-height:27px;
	}
	.gbutn{
		width: 100%;
		height: 0.45rem;
		line-height: 0.45rem;
		position: fixed;
		bottom: 0;
		background:#18BD6F;
		color:#fff;
		font-size: 16px;
		text-align: center;
	}
	.warpC{
		width: 100%;
		min-height: 1rem;
		background: #fff;
		padding-top:0.2rem;
		margin-top:0.05rem;
		margin-bottom:0.5rem;
	}
	.warpC h4{
		font-size: 16px;
		color:#27282D;
		text-indent: 0.15rem;
		font-weight: bold;
	}
	.Clist ul{
		width: 90%;
		margin: 0 auto;
		margin-top: 0.15rem;
	}
	.Clist ul li{
		height: 1rem;
		border-bottom: 1px solid #DDDEE3;
		margin-bottom: 0.15rem;
	}
	.Clist ul li dl{
		display: flex;
	}
	.Clist ul li dl dt{
		min-width:0.9rem;
		max-width: 0.9rem;
		height:0.86rem;
		background: #ccc;
		margin-right: 0.13rem;
	}
	.Clist ul li dl dt img{
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.Clist ul li dl dd p{
		font-size: 16px;
		line-height:24px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp:2;
		-webkit-box-orient: vertical;
	}
	.Clist ul li dl dd span{
		font-size: 13px;
		color:#DD2815;
		display: inline-block;
		margin-top: 0.12rem;
	}
</style>